// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var HistoryType;
(function (HistoryType) {
    HistoryType[HistoryType["DEFAULT"] = 0] = "DEFAULT";
    HistoryType[HistoryType["BID"] = 1] = "BID";
    HistoryType[HistoryType["QUOTE_LEVEL1"] = 1] = "QUOTE_LEVEL1";
    HistoryType[HistoryType["QUOTE_LEVEL2"] = 2] = "QUOTE_LEVEL2";
    HistoryType[HistoryType["QUOTE_TRADES"] = 4] = "QUOTE_TRADES";
    HistoryType[HistoryType["LAST"] = 4] = "LAST";
    HistoryType[HistoryType["QUOTE_OPTIONS"] = 8] = "QUOTE_OPTIONS";
    HistoryType[HistoryType["QUOTE_INSTRUMENT_PRICES"] = 16] = "QUOTE_INSTRUMENT_PRICES";
    HistoryType[HistoryType["QUOTE_INSTRUMENT_DAY_PRICES"] = 12] = "QUOTE_INSTRUMENT_DAY_PRICES";
    HistoryType[HistoryType["QUOTE_INSTRUMENT_DAY_BAR"] = 32] = "QUOTE_INSTRUMENT_DAY_BAR";
    /// <summary>
    /// искусственный режим - бары по аскам
    /// </summary>
    HistoryType[HistoryType["ASK"] = 1000] = "ASK";
    HistoryType[HistoryType["QUOTE_ASK"] = 1000] = "QUOTE_ASK";
})(HistoryType || (HistoryType = {}));
